import { z } from "zod";
import { LastDocumentSuccessResponse } from "./DocumentSuccessResponse";

export type GetLastDocumentSuccessResponse = {
  data: LastDocumentSuccessResponse;
};

export type GetDocumentSuccessResponse = {
  data: {
    document: {
      id: string;
      contractId: string | null;
      title: string;
      html: string;
    };
    jsonData: Record<string, any>;
  };
};

export type GetDocumentErrorResponse = {
  data: {
    errorMessage: string;
  };
};

export type GetDocumentResponse =
  | GetDocumentSuccessResponse
  | GetDocumentErrorResponse
  | GetLastDocumentSuccessResponse;

export const NextVisitSchema = z.object({
  contractId: z.number(),
  title: z.string(),
  serviceDate: z.string(),
  serviceTime: z.string(),
});

export const GetLastDocumentSuccessResponseSchema = z.object({
  data: z
    .object({
      isLastDocument: z.literal(true),
      successMessage: z.string(),
      nextVisit: NextVisitSchema.optional(),
    })
    .passthrough(),
});

export const GetDocumentSuccessResponseSchema = z.object({
  data: z
    .object({
      document: z.object({
        id: z.string(),
        contractId: z.string().nullable(),
        title: z.string(),
        html: z.string(),
      }),
      isLastDocument: z.boolean().optional(),
      jsonData: z.record(z.string(), z.any()),
    })
    .passthrough(),
});

export const GetDocumentErrorResponseSchema = z.object({
  data: z
    .object({
      errorMessage: z.string(),
    })
    .passthrough(),
});

export const GetDocumentResponseSchema = z.union([
  GetDocumentSuccessResponseSchema,
  GetDocumentErrorResponseSchema,
  GetLastDocumentSuccessResponseSchema,
]);

export function checkIsGetDocumentErrorResponse(
  response: GetDocumentResponse
): response is GetDocumentErrorResponse {
  return "errorMessage" in response.data;
}

export const checkIsGetLastDocumentSuccessResponse = (
  response: GetDocumentResponse
): response is GetLastDocumentSuccessResponse => {
  return (
    "isLastDocument" in response.data && response.data.isLastDocument === true
  );
};
